import React, { useState } from 'react';
import Scene from './Scene';

import './App.css';

export default function App(props){
  const [sceneOpened, setSceneOpened] = useState(true)

  return sceneOpened ? 
    <Scene {...props}  arm={props.initial} close={()=> setSceneOpened(false)} /> :  
    <button className="open-configurator" onClick={()=> setSceneOpened(true)}>Open configurator</button>
}
